import SwipeListener from "swipe-listener";

var karusell = (function () {
  function ResizeKarusell(karusell) {
    let itemWidth = 0;
    let viewport = window.innerWidth;
    let karusellWidth = karusell.querySelector(".karusell").offsetWidth;
    let track = karusell.querySelector(".track");
    let slidecount = track.querySelectorAll(".slide").length;
    let tabMarker = 1;

    if (viewport >= window.xxlMin) {
      itemWidth = (karusellWidth + 32) / 4;
      tabMarker = 3;
    } else if (viewport >= window.lgMin) {
      itemWidth = (karusellWidth + 32) / 3;
      tabMarker = 2;
    } else if (viewport >= window.mdMin) {
      itemWidth = (karusellWidth + 8) / 2 - 40;
      tabMarker = 2;
    } else if (viewport < window.mdMin) {
      itemWidth = (karusellWidth + 8) / 1 - 80;
    }

    itemWidth = Math.round(itemWidth);

    track.style.transform = `translateX(-${0}px)`;
    track.style.width = slidecount * itemWidth + "px";

    var tabI = 0;
    let slides = track.querySelectorAll(".slide");
    slides.forEach(function (elem) {
      elem.style.width = itemWidth + "px";
      elem.classList.remove("tab");
      if (tabI == tabMarker) {
        elem.classList.add("tab");
        if (tabMarker > 1) {
          tabI = 2;
        } else {
          tabI = 1;
        }
      } else {
        tabI++;
      }
    });

    tabI = 0;
    for (var i = slides.length - 1; i >= 0; i--) {
      let slide = slides[i];
      slide.classList.remove("tabback");
      if (tabI == tabMarker) {
        slide.classList.add("tabback");
        if (tabMarker > 1) {
          tabI = 2;
        } else {
          tabI = 1;
        }
      } else {
        tabI++;
      }
    }

    if (track.offsetWidth < karusellWidth) {
      karusell.querySelector(".prev").classList.remove("d-block");
      karusell.querySelector(".next").classList.add("d-none");
    } else {
      karusell.querySelector(".prev").classList.remove("d-block");
      karusell.querySelector(".next").classList.remove("d-none");
    }
  }

  function click(ell, karusell) {
    let viewport = window.innerWidth;
    let moveslides = 1;

    if (viewport >= window.xxlMin) {
      moveslides = 2;
    } else if (viewport >= window.lgMin) {
      moveslides = 1;
    } else if (viewport >= window.mdMin) {
      moveslides = 2;
    }

    SnurraKarusell(ell, karusell, moveslides);
  }

  function SnurraKarusell(e, karusell, s) {
    let prev = karusell.querySelector(".prev");
    let next = karusell.querySelector(".next");
    let track = karusell.querySelector(".track");
    let karusellWidth = karusell.querySelector(".karusell").offsetWidth;
    let itemWidth = track.querySelectorAll(".slide")[0].offsetWidth;
    let divStyle = track.style.transform;
    let values = divStyle.match(/-?[\d\.]+/g);
    let xds = Math.abs(values[0]);
    let translateXval = "";
    let itemsCondition;

    if (window.innerWidth <= window.mdMax) {
      itemsCondition = track.offsetWidth - karusellWidth - 8;
    } else {
      itemsCondition = track.offsetWidth - karusellWidth - 32;
    }

    if (e == 0) {
      translateXval = parseInt(xds) - parseInt(itemWidth * s);

      if (
        parseInt(xds) + itemWidth * s + 80 >= track.offsetWidth &&
        window.innerWidth <= window.mdMax
      ) {
        translateXval = translateXval + 40;
      }

      next.classList.remove("d-none");

      if (translateXval <= itemWidth / 2) {
        translateXval = 0;
        prev.classList.remove("d-block");
      }
    } else if (e == 1) {
      translateXval = parseInt(xds) + parseInt(itemWidth * s);

      if (parseInt(xds) == 0 && window.innerWidth <= window.mdMax) {
        translateXval = translateXval - 40;
      }

      prev.classList.add("d-block");

      if (translateXval >= itemsCondition - itemWidth / 2) {
        translateXval = itemsCondition;
        next.classList.add("d-none");
      }
    }
    track.style.transform = `translateX(-${translateXval}px)`;
  }

  /* ********** Exponerade funktioner     */
  function initKarusell() {
    document.querySelectorAll(".karusellblock").forEach(function (elem) {
      const prev = elem.querySelector(".prev");
      const next = elem.querySelector(".next");
      const track = elem.querySelector(".track");

      ResizeKarusell(elem);

      window.addEventListener("resize", () => {
        ResizeKarusell(elem);
      });

      prev.addEventListener("click", () => {
        click(0, elem);
      });

      next.addEventListener("click", () => {
        click(1, elem);
      });

      var listener = SwipeListener(track);
      track.addEventListener("swipe", function (e) {
        let directions = e.detail.directions;
        if (directions.right && window.innerWidth <= window.mdMax) {
          console.log("Swiped right.");
          click(0, elem);
        }

        if (directions.left && window.innerWidth <= window.mdMax) {
          console.log("Swiped left.");
          click(1, elem);
        }
      });

      track.addEventListener("keyup", function (e) {
        if (e.keyCode == 9) {
          const element = document.activeElement;
          let slide = element.closest(".col.slide");

          if (e.shiftKey) {
            if (slide.classList.contains("tabback")) {
              click(0, elem);
            }
          } else {
            if (slide.classList.contains("tab")) {
              click(1, elem);
            }
          }
        }
      });
    });
  }

  /* ********** Returnera exponerat gränssnitt     */
  return {
    initKarusell: initKarusell,
  };
})();

export default karusell;
